import { QueryClientProvider } from "@tanstack/react-query";
import { enableMapSet } from "immer";
import { NuqsAdapter } from "nuqs/adapters/react-router/v6";
import React from "react";
import ReactDOM from "react-dom/client";

import { initSentry } from "@oneleet/utils";

import Router from "./generated_router";
import "./index.css";
import queryClient from "./query_client";

enableMapSet();

void initSentry({ tunnel: `${import.meta.env.VITE_API_URL}/api/v1/sentry` });

const root = document.getElementById("root");

if (!root) {
  throw new Error("Couldn't find root");
}

ReactDOM.createRoot(root).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <NuqsAdapter>
        <Router />
      </NuqsAdapter>
    </QueryClientProvider>
  </React.StrictMode>,
);
